import { ImageOrientation } from '@space-core/components/customImage/enum'

import { CardOrientation } from './enum'
import BaseImageContainer from './imageContainer'

import type { BaseCardProps } from './types'

import Card from '../../card'

const MobileBaseCard = ({
  children,
  avatar = '',
  avatarAltText = '',
  thumbnailImage,
  coverImage,
  imageAlt = '',
  verticalCoverPage = '',
  verticalAltText = '',
  containerOrientation = CardOrientation.HORIZONTAL,
  imageOrientation = ImageOrientation.HORIZONTAL,
  icon,
  iconSize = 'md',
  iconRounded = false,
  tag,
  showDepthEffect = false,
  themeMode,
  freeSignup
}: BaseCardProps) => {
  return (
    <Card className='_rounded-lg _border-0 _w-full _bg-transparent' data-test='mobile-base-card'>
      <Card.Header className='_p-0'>
        <BaseImageContainer
          icon={icon}
          iconRounded={iconRounded}
          iconSize={iconSize}
          imageAlt={imageAlt}
          coverImage={coverImage}
          avatar={avatar}
          avatarAltText={avatarAltText}
          thumbnailImage={thumbnailImage}
          verticalCoverPage={verticalCoverPage}
          verticalAltText={verticalAltText}
          containerOrientation={containerOrientation}
          imageOrientation={imageOrientation}
          tag={tag}
          showDepthEffect={showDepthEffect}
          themeMode={themeMode}
          freeSignup={freeSignup}
        />
      </Card.Header>
      {imageOrientation === ImageOrientation.HORIZONTAL && (
        <Card.Body className='_p-0 _pt-4 _d-flex _flex-column _align-items-start'>
          {children}
        </Card.Body>
      )}
    </Card>
  )
}

export default MobileBaseCard
